module.exports = __webpack_public_path__ + "static/media/wifiqube-logo.04444fc7.png";